import axios from 'axios';
import { IUserV2 } from '../../types';

interface IParams {
  fid?: string;
  context: {
    apiUrl: string;
    user?: IUserV2;
  };
}

/**
 * Get batch index file from the server
 *
 * @param {string} fid Flowy id of the RootGizmo
 *
 * @returns object containig data from the server
 */
function getBatchIndex({ fid, context }: IParams): Promise<any> {
  return new Promise<any>(async resolve => {
    const { apiUrl, user } = context;

    if (fid && user && user.credentials) {
      const credentials: any = user.credentials;
      const url = `${apiUrl}/batch_api/v1/root_gizmo/data/${fid}`;

      const response = await axios({
        url,
        method: 'POST',
        data: {},
        responseType: 'blob',
        headers: {
          ...credentials,
        },
      });

      if (response.status === 200) {
        return resolve({
          data: response.data,
        });
      }
    }

    resolve(undefined);
  });
}

export default getBatchIndex;
